
import { Question } from '../types';

export const qur101RevelationQuestions: Question[] = [
  {
    id: 'qur031',
    text: 'What were the characteristics of the angel Jibrīl when he appeared to the Prophet ﷺ in human form?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'He had extremely white clothing', isCorrect: true },
      { id: 'b', text: 'He had very black hair', isCorrect: true },
      { id: 'c', text: 'He appeared as if he had not traveled (no dust or signs of journey)', isCorrect: true },
      { id: 'd', text: 'No one present recognized him', isCorrect: true },
      { id: 'e', text: 'He always appeared elderly', isCorrect: false }
    ],
    explanation: 'When Jibrīl appeared in human form to the Prophet ﷺ, he was described as having the whitest clothing, blackest hair, appearing as if he had not traveled (no dust or signs of journey), and no one present would recognize him despite his distinctive appearance.',
    topic: 'qur101'
  },
  {
    id: 'qur032',
    text: 'What was significant about the interactions between Jibrīl and the Prophet ﷺ toward the end of the Prophet\'s life?',
    type: 'single',
    options: [
      { id: 'a', text: 'Jibrīl stopped appearing completely', isCorrect: false },
      { id: 'b', text: 'Jibrīl would ask questions and confirm the Prophet\'s answers', isCorrect: true },
      { id: 'c', text: 'Jibrīl only appeared in his true angelic form', isCorrect: false },
      { id: 'd', text: 'Jibrīl revealed entirely new chapters of the Qur\'ān', isCorrect: false }
    ],
    explanation: 'Toward the end of the Prophet\'s ﷺ life, Jibrīl would sometimes sit with the companions, touch the Prophet, ask him questions, and then confirm the truth of his answers. This served as a form of review and codification of knowledge, helping to carry Islamic teachings forward.',
    topic: 'qur101'
  },
  {
    id: 'qur033',
    text: 'Why did the Prophet ﷺ see Jibrīl in his true form only twice?',
    type: 'single',
    options: [
      { id: 'a', text: 'Because it was extremely overwhelming and frightening', isCorrect: true },
      { id: 'b', text: 'Because Jibrīl preferred human form', isCorrect: false },
      { id: 'c', text: 'Because other people were usually present', isCorrect: false },
      { id: 'd', text: 'Because the Prophet ﷺ requested human form', isCorrect: false }
    ],
    explanation: 'The Prophet ﷺ saw Jibrīl in his true angelic form only twice because it was extremely overwhelming. Angels in their true form are so grand, large, and spectacular that the experience is frightening and overwhelming for humans. Jibrīl\'s true form was described as being beyond the sky.',
    topic: 'qur101'
  },
  {
    id: 'qur034',
    text: 'What is the primary difference between how Prophet Muhammad ﷺ received direct discourse from Allāh compared to Prophet Mūsā (Moses)?',
    type: 'single',
    options: [
      { id: 'a', text: 'Prophet Muhammad ﷺ was invited, while Prophet Mūsā asked to see Allāh', isCorrect: true },
      { id: 'b', text: 'Prophet Muhammad ﷺ received it through dreams, while Prophet Mūsā received it while awake', isCorrect: false },
      { id: 'c', text: 'Prophet Muhammad ﷺ received it in writing, while Prophet Mūsā received it verbally', isCorrect: false },
      { id: 'd', text: 'Prophet Muhammad ﷺ received it on earth, while Prophet Mūsā received it on Mount Sinai', isCorrect: false }
    ],
    explanation: 'A key difference in how Prophet Muhammad ﷺ and Prophet Mūsā received direct discourse from Allāh is that Prophet Muhammad ﷺ was invited for the discourse, whereas Prophet Mūsā asked to see Allāh (and when exposed to His nūr, passed out). This highlights the special position of Prophet Muhammad ﷺ.',
    topic: 'qur101'
  },
  {
    id: 'qur035',
    text: 'What happens at the Lawḥ al-Maḥfūẓ (Preserved Tablet)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Angels perform ṭawāf around their version of the Ka\'bah', isCorrect: true },
      { id: 'b', text: '70,000 angels make ṭawāf at once', isCorrect: true },
      { id: 'c', text: 'Each angel gets only one ṭawāf before being replaced', isCorrect: true },
      { id: 'd', text: 'The Qur\'ān descended to it all at once', isCorrect: true },
      { id: 'e', text: 'Humans can occasionally visit it in dreams', isCorrect: false }
    ],
    explanation: 'At the Lawḥ al-Maḥfūẓ (Preserved Tablet), angels perform ṭawāf around their version of the Ka\'bah, with 70,000 angels making ṭawāf at once. Each angel gets only one ṭawāf before being replaced by another. The Qur\'ān was initially revealed to the Lawḥ al-Maḥfūẓ all at once before being sent to the lowest level of Heaven.',
    topic: 'qur101'
  },
  {
    id: 'qur036',
    text: 'What does "samā\' al-dunyā" refer to in the context of Qur\'ānic revelation?',
    type: 'single',
    options: [
      { id: 'a', text: 'The lowest level of Heaven', isCorrect: true },
      { id: 'b', text: 'The earthly life of humans', isCorrect: false },
      { id: 'c', text: 'The material world', isCorrect: false },
      { id: 'd', text: 'The place where souls gather before judgment', isCorrect: false }
    ],
    explanation: 'In the context of Qur\'ānic revelation, "samā\' al-dunyā" refers to the lowest level of Heaven. After the Qur\'ān was revealed to the Lawḥ al-Maḥfūẓ, it was sent down to samā\' al-dunyā before being gradually revealed to Prophet Muhammad ﷺ over 23 years.',
    topic: 'qur101'
  },
  {
    id: 'qur037',
    text: 'Which of the following are benefits of the gradual revelation of the Qur\'ān as opposed to it being revealed all at once?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'To steady the Prophet\'s heart and strengthen his faith', isCorrect: true },
      { id: 'b', text: 'To address specific events and questions as they arose', isCorrect: true },
      { id: 'c', text: 'To allow for progressive legislation and guidance', isCorrect: true },
      { id: 'd', text: 'To give people time to memorize smaller portions', isCorrect: true },
      { id: 'e', text: 'To prevent other prophets from learning the full message', isCorrect: false }
    ],
    explanation: 'The gradual revelation of the Qur\'ān had several benefits: it steadied the Prophet\'s heart and strengthened his faith, allowed verses to come down as responses to specific events (like the Battle of Uḥud or to clear Ā\'ishah\'s name), provided progressive legislation and guidance as the Muslim community grew, and made memorization more manageable by revealing smaller portions over time.',
    topic: 'qur101'
  },
  {
    id: 'qur038',
    text: 'What is the significance of the last revelation before the Prophet ﷺ passed away?',
    type: 'single',
    options: [
      { id: 'a', text: 'It was revealed nine nights before his passing', isCorrect: true },
      { id: 'b', text: 'It announced the completion of his mission', isCorrect: false },
      { id: 'c', text: 'It named his successor explicitly', isCorrect: false },
      { id: 'd', text: 'It predicted events after his death', isCorrect: false }
    ],
    explanation: 'The last revelation before the Prophet ﷺ passed away is significant because it occurred just nine nights before his passing. This timing marked the end of the revelation period and the completion of the Qur\'ān as we know it today.',
    topic: 'qur101'
  },
  {
    id: 'qur039',
    text: 'What are examples of situations where verses were revealed in response to specific events?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The Battle of Uḥud', isCorrect: true },
      { id: 'b', text: 'To clear Ā\'ishah\'s name in Sūrah Nūr', isCorrect: true },
      { id: 'c', text: 'The Treaty of Hudaibiyyah', isCorrect: true },
      { id: 'd', text: 'The conquest of Constantinople', isCorrect: false }
    ],
    explanation: 'Verses of the Qur\'ān were often revealed in response to specific situations, including: during or after the Battle of Uḥud to provide guidance; in Sūrah Nūr to clear Ā\'ishah\'s name from false accusations; and following events like the Treaty of Hudaibiyyah to provide divine perspective on earthly events.',
    topic: 'qur101'
  },
  {
    id: 'qur040',
    text: 'What is distinctive about Ḥadīth Qudsī compared to other Ḥadīth?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It contains the words of Allāh but not in their precise form', isCorrect: true },
      { id: 'b', text: 'It communicates exactly what Allāh means, but not necessarily letter for letter', isCorrect: true },
      { id: 'c', text: 'It comes primarily through direct discourse with Allāh', isCorrect: true },
      { id: 'd', text: 'It can be recited in prayer like the Qur\'ān', isCorrect: false }
    ],
    explanation: 'Ḥadīth Qudsī is distinctive because it contains the words of Allāh but not in their precise form. It communicates exactly what Allāh means, but not necessarily letter for letter as in the Qur\'ān. Ḥadīth Qudsī primarily comes through direct discourse between Allāh and the Prophet ﷺ, but unlike the Qur\'ān, it cannot be recited in prayer.',
    topic: 'qur101'
  }
];
